import { proxy, useSnapshot } from "valtio";

const vState = proxy({ validations: {} });

const useFormValidation = (entityId) => {
    const snap = useSnapshot(vState);
    const validated = snap.validations[entityId] || false;

    const setValidated = (boolean) => {
        vState.validations[entityId] = boolean;
    };

    return { validated, setValidated };
};

export default useFormValidation



